// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const groupRouter =
    {
      path:  roterPre+`/group`,
      name: 'system_group_combine',
      meta: {
        icon: 'dashboard',
        title: '组合数据'
      },
      alwaysShow: true,
      component: Layout,
      children: [
        {
          path: 'list',
          name: 'system_group_lst',
          meta: {
            title: '组合数据'
          },
          component: () => import('@/views/system/groupData/list.vue')
        },
        {
          path: 'data/:id?',
          name: 'system_group_data',
          meta: {
            title: '组合数据列表'
          },
          component: () => import('@/views/system/groupData/data.vue')
        },
        {
          path: 'config/:id?',
          name: 'system_group_data_',
          meta: {
            title: '组合数据列表'
          },
          component: () => import('@/views/system/groupData/data.vue')
        },
        {
          path: 'topic/:id?',
          name: 'system_group_topic',
          meta: {
            title: '专场列表'
          },
          component: () => import('@/views/system/topic/data.vue')
        }
      ]
    }

export default groupRouter as RouteRecordRaw